// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","341":"component---src-pages-portfolio-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"06f1f15d312b8d6ffcad","341":"bd633631eca8f9cc7f45","691":"2c1a416037bf0163f5c8","731":"d07d8188e75bf5a4b74d","843":"9e6b01c437ea801c1b7e"}[chunkId] + ".js";
};